import { markSvg, WORDMARK } from '../../../shared/brand.js'

// The TempDash logo: the symbol plus lowercase "tempdash", bold with tight
// tracking, ink on light and white on dark.
//
// ⛔ There is ONE logo and it lives in shared/brand.js. This component draws
// `markSvg()` — the same vector the apps render and the same source the favicons,
// PWA icons and app icons are generated from (scripts/brand-assets.mjs). It used
// to ship /brand-mark.png, which meant the site served a raster of a vector we
// already had, blurred it on retina, and would have gone stale the next time
// ACTIVE_MARK changed. Never hand draw a second mark in code.
//
// The turquoise in the mark is the ONE place turquoise is allowed on this site
// (spec §2.1 rule 1). It is the logo.
//
// Variants: "light" for the canvas and white surfaces (default), "dark" for navy
// sections. Sizes scale symbol and word together, from WORDMARK’s own ratios.

const SIZES = { xs: 10, sm: 14, md: 18, lg: 24, xl: 40 }

export default function BrandLogo({ size = 'md', variant = 'light', className = '' }) {
  const px = SIZES[size] ?? SIZES.md
  return (
    <div
      className={`flex items-center ${className}`}
      style={{ gap: `${WORDMARK.gap}em`, fontSize: px }}
      role="img"
      aria-label="TempDash"
    >
      <span
        className="shrink-0 block"
        style={{ width: `${WORDMARK.markScale}em`, height: `${WORDMARK.markScale}em` }}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: markSvg({ size: '100%' }) }}
      />
      <span
        className="font-bold leading-none"
        style={{
          color: variant === 'dark' ? WORDMARK.onDark : WORDMARK.ink,
          letterSpacing: `${WORDMARK.tracking}em`,
        }}
      >
        {WORDMARK.text}
      </span>
    </div>
  )
}
